import { pushDataLayerEvent } from "./pushDataLayerEvent.helper";

const EMAIL_PATTERN = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
const CARD_PATTERN = /\b(?:\d[ -]*?){13,19}\b/g;

export type AnalyticsAuthMethod = "email" | "google";

export type CheckoutErrorStep = "payment_method" | "confirm" | "3ds";

/**
 * Strips emails and card-like numbers, then caps length for analytics params.
 */
export const sanitizeAnalyticsMessage = (message: unknown): string => {
  const text = String(message ?? "")
    .replace(EMAIL_PATTERN, "[redacted]")
    .replace(CARD_PATTERN, "[redacted]")
    .replace(/\s+/g, " ")
    .trim();

  if (!text) return "unknown";
  return text.slice(0, 100);
};

export const checkoutErrorStep = (code: string): CheckoutErrorStep => {
  const normalized = code.toLowerCase();
  if (
    normalized.includes("requires_action") ||
    normalized.includes("authentication") ||
    normalized.includes("3ds")
  ) {
    return "3ds";
  }
  if (
    normalized === "validation" ||
    normalized.includes("card") ||
    normalized.includes("cvc") ||
    normalized.includes("payment_method") ||
    normalized.startsWith("stripe_")
  ) {
    return "payment_method";
  }
  return "confirm";
};

export const pushAnalyticsError = (input: {
  event: "checkout_error" | "signup_error" | "login_error";
  errorCode: string;
  errorMessage: string;
  errorStep: string;
  method?: AnalyticsAuthMethod;
}) => {
  const errorCode = sanitizeAnalyticsMessage(input.errorCode);
  pushDataLayerEvent({
    event: input.event,
    error_code: errorCode,
    error_message: sanitizeAnalyticsMessage(input.errorMessage),
    error_step: input.errorStep,
    ...(input.method ? { method: input.method } : {}),
  });
};
